/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState } from 'react';
import { jsx, css } from '@emotion/react';
import { EBrandingColorsOptions, EPickerTheme, ETypography, ETypographyColor, Icons } from '../../../types';
import { useColors } from '../../../hooks/useColors';
import { Typography } from '../../../atoms';
import { Button } from '../../../components/Button';
import { BnIcon } from '../../../components/icons_v2';
import { gapCss, flexCss } from '../../../styles/utils';
import { SizeEnum } from '../../../lib/constants';

const alignItemsCenterCss = css`
	align-items: center;
`;

interface DownloadButtonProps {
	label: string;
	handleDownload: (callback: () => void) => void;
}

export const DownloadButton = ({ label, handleDownload }: DownloadButtonProps) => {
	const [isDownloadLoading, setDownloadLoading] = useState(false);
	const { colors } = useColors();

	const onDownloadClick = () => {
		if (isDownloadLoading) return;
		
		setDownloadLoading(true);
		try {
			handleDownload(() => setDownloadLoading(false));
		} catch {
			setDownloadLoading(false);
		}
	};

	return (
		<Button
			data-aid="button-checkoutCardButton-toggle"
			sizer={SizeEnum.MEDIUM}
			isProcessing={isDownloadLoading}
			loadingColor={EBrandingColorsOptions.bg_text_primary}
			theme={EPickerTheme.BASIC}
			aria-label={label}
			onClick={onDownloadClick}
		>
			<div css={[flexCss, gapCss(8), alignItemsCenterCss]}>
				<BnIcon
					icon={Icons.download}
					color={colors.tx_text_primary}
				/>
				<Typography type={ETypography.body1} color={ETypographyColor.primary}>
					{label}
				</Typography>
			</div>
		</Button>
	);
};

